import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { environment } from '../config/environment';

// Initialize Firebase
const app = initializeApp(environment.firebase);

// Initialize services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// Connect to emulators in development
if (environment.useEmulators) {
  try {
    console.log('🔧 Connecting to Firebase emulators...');
    
    // Connect to Auth emulator
    connectAuthEmulator(auth, `http://${environment.emulators.auth}`, { disableWarnings: true });
    console.log(`✅ Connected to Auth emulator on port ${environment.emulators.auth.split(':')[1]}`);
    
    // Connect to Firestore emulator
    connectFirestoreEmulator(db, environment.emulators.firestore.split(':')[0], parseInt(environment.emulators.firestore.split(':')[1]));
    console.log(`✅ Connected to Firestore emulator on port ${environment.emulators.firestore.split(':')[1]}`);
    
    // Connect to Storage emulator
    connectStorageEmulator(storage, environment.emulators.storage.split(':')[0], parseInt(environment.emulators.storage.split(':')[1]));
    console.log(`✅ Connected to Storage emulator on port ${environment.emulators.storage.split(':')[1]}`);
    
    console.log('🎉 All emulators connected successfully!');
  } catch (error) {
    console.error('❌ Failed to connect to emulators:', error);
  }
} else {
  console.log('🚀 Connected to production Firebase services');
}
